import React from "react";

const ICON_PATHS: Record<string, React.ReactNode> = {
  "Co-Purchase Recommendations": <path d="M18 20V10M12 20V4M6 20v-6" />,
  "Compatibility Recommendations": (
    <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18" />
  ),
  Similarity: (
    <>
      <circle cx="9" cy="12" r="3" />
      <circle cx="15" cy="12" r="3" />
      <path d="M6 20.7a9 9 0 1 1 12 0" />
    </>
  ),
};

const StrategyIcon = ({ name, type }: { name: string; type?: string }) => {
  const fallback =
    type === "Substitution" ? ICON_PATHS.Similarity : ICON_PATHS["Co-Purchase Recommendations"];

  return (
    <svg
      viewBox="0 0 24 24"
      className="tw-h-[17px] tw-w-[17px]"
      style={{
        stroke: "currentColor",
        fill: "none",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      aria-hidden="true"
    >
      {ICON_PATHS[name] ?? fallback}
    </svg>
  );
};

export default StrategyIcon;
